var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    viewBox: "-2 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface2671593"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,54.117647%,39.607843%)",
      fillOpacity: 1
    },
    d: "M 19.207031 2.417969 L 10.542969 2.417969 L 10.542969 17.582031 L 19.207031 17.582031 C 19.507812 17.582031 19.75 17.339844 19.75 17.042969 L 19.75 2.957031 C 19.75 2.660156 19.507812 2.417969 19.207031 2.417969 Z M 19.207031 2.417969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,91.372549%,90.588235%)",
      fillOpacity: 1
    },
    d: "M 10 12.707031 L 17.582031 12.707031 L 17.582031 13.792969 L 10 13.792969 Z M 10 14.875 L 17.582031 14.875 L 17.582031 15.957031 L 10 15.957031 Z M 13.25 5.125 C 11.457031 5.125 10 6.582031 10 8.375 C 10 10.167969 11.457031 11.625 13.25 11.625 C 15.042969 11.625 16.5 10.167969 16.5 8.375 L 13.25 8.375 Z M 13.25 5.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,91.372549%,90.588235%)",
      fillOpacity: 1
    },
    d: "M 14.332031 4.042969 L 14.332031 7.292969 L 17.582031 7.292969 C 17.582031 5.496094 16.128906 4.042969 14.332031 4.042969 Z M 14.332031 4.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,29.019608%,9.803922%)",
      fillOpacity: 1
    },
    d: "M 11.625 19.75 L 0.25 17.582031 L 0.25 2.417969 L 11.625 0.25 Z M 11.625 19.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.113281 6.207031 L 3.5 6.207031 L 3.5 13.792969 L 5.125 13.792969 L 5.125 11.179688 L 5.964844 11.179688 C 6.863281 11.179688 7.578125 10.941406 8.113281 10.472656 C 8.648438 10.003906 8.917969 9.386719 8.917969 8.625 C 8.917969 7.015625 7.980469 6.207031 6.113281 6.207031 Z M 5.824219 9.882812 L 5.125 9.882812 L 5.125 7.519531 L 5.824219 7.519531 C 6.714844 7.519531 7.160156 7.910156 7.160156 8.6875 C 7.160156 9.484375 6.714844 9.882812 5.824219 9.882812 Z M 5.824219 9.882812 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.c4340eb3.svg";
export { ForwardRef as ReactComponent };